(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const alignInitialThumbnails = (root) => {
    root.querySelectorAll('product-gallery-navigation[align-selected]').forEach((navigation) => {
      if (navigation.dataset.pcInitialThumbnailAligned || navigation.clientWidth === 0 || navigation.clientHeight === 0) return;
      const selected = navigation.querySelector('button[aria-current="true"]:not([hidden])');
      if (!selected) return;
      const rail = navigation.getBoundingClientRect();
      const item = selected.getBoundingClientRect();
      if (navigation.scrollWidth > navigation.clientWidth && (item.left < rail.left || item.right > rail.right)) {
        navigation.scrollLeft += item.left - rail.left - (navigation.clientWidth - item.width) / 2;
      }
      if (navigation.scrollHeight > navigation.clientHeight && (item.top < rail.top || item.bottom > rail.bottom)) {
        navigation.scrollTop += item.top - rail.top - (navigation.clientHeight - item.height) / 2;
      }
      navigation.dataset.pcInitialThumbnailAligned = 'true';
    });
  };
  const initialize = (root = document) => {
    customElements.whenDefined('product-gallery-navigation').then(() => {
      requestAnimationFrame(() => requestAnimationFrame(() => alignInitialThumbnails(root)));
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
